import { useQuery } from "@tanstack/react-query";
import { PlayerCard } from "../../../../components/PlayerCard";
import NoDataFound from "../../../../components/common/NoDataFound";
import { useAppSelector } from "../../../../redux/hooks";
import { selectSelectedLeagueId } from "../../../../redux/slice/selectedLeagueSlice";
import { QUERY_KEY } from "../../../../services/queryEndPoint";
import { fetchSearchPlayersByLeague } from "../../request/api/requestApi";
import type { IPlayerByLeague } from "../../squads/types/squads";
import "./TournamentPlayersTab.scss";

const TournamentPlayersTab = () => {
  const selectedLeagueId = useAppSelector(selectSelectedLeagueId);

  const { data: players = [], isLoading, isError } = useQuery({
    queryKey: [QUERY_KEY.getAllPlayersByLeague, selectedLeagueId, "tournament-details-player-tab"],
    enabled: !!selectedLeagueId,
    queryFn: () => fetchSearchPlayersByLeague(selectedLeagueId!),
  });

  if (!selectedLeagueId) {
    return (
      <div className="tournament-players-tab">
        <NoDataFound message="SELECT A LEAGUE TO VIEW PLAYERS" />
      </div>
    );
  }

  if (isLoading) {
    return <div className="tournament-players-tab__loading">Loading...</div>;
  }

  if (isError) {
    return (
      <div className="tournament-players-tab__error" role="alert">
        Could not load players. Please try again.
      </div>
    );
  }

  if (!players.length) {
    return (
      <div className="tournament-players-tab">
        <NoDataFound message="NO PLAYERS FOUND" />
      </div>
    );
  }

  return (
    <div className="tournament-players-tab">
      <div className="player-card-wrap">
        {players.map((player, index) => (
          <PlayerCard
            key={player.playerId ?? `player-${index}`}
            player={player as IPlayerByLeague}
          />
        ))}
      </div>
    </div>
  );
};

export default TournamentPlayersTab;
